<div *ngIf="exibirLoader">
  <app-loader></app-loader>
</div>

<div
  class="container"
  *ngIf="
    (solicitacoesPendentes.length > 0 || solicitacoesConcluidas.length > 0) &&
    !carregandoSolicitacoes
  "
>
  <div class="row" *ngIf="exibeDivSemSolicitacoes">
    <div class="col-12 mb-4 d-flex justify-content-center">
      <img
        class="opcao__icone"
        src="assets/images/icons/sem_solicitacoes.png"
        alt=""
      />
    </div>
    <div class="col-12 d-flex justify-content-center">
      <h5 class="lovers-font--bold">Sem solicitações...</h5>
    </div>
  </div>

  <p
    class="header_status"
    *ngIf="!exibeDivSemSolicitacoes && solicitacoesPendentes.length > 0"
  >
    Pendentes
  </p>

  <div
    class="row"
    [ngClass]="div - card - pendente"
    *ngFor="let item of solicitacoesPendentes"
  >
    <div
      class="col-12"
      [ngClass]="{
        'border--bottom':
          item != solicitacoesPendentes[solicitacoesPendentes.length - 1]
      }"
    >
      <p class="font-titulo">
        <img
          class="statusMensagem"
          [src]="'assets/images/icons/nao_lida.png'"
        />{{
          item.idTipoAprovacao == 1
            ? "Solicitação de cadastro de menor de idade"
            : ""
        }}
      </p>
      <p class="font-data">{{ item.dataInicio | date: "dd/MM/yyyy" }}</p>
      <p class="font-descricao">{{ item.descricaoSolicitante }}</p>

      <p class="font-descricao">
        Por meio deste aceite, declaro que sou o responsável legal do menor que
        solicitou o cadastro no programa “Cacau Lovers”, bem como que o assisto
        nesse sentido.
      </p>
      <p class="font-descricao">
        Declaro ainda que, caso não seja o representante legal do menor, com
        relação ao qual o cadastro será concluído por meio deste aceite,
        responderei nas esferas competentes, de forma exclusiva, pelo aceite
        desautorizado do cadastro e pelo acesso indevido aos dados nele
        constantes.
      </p>

      <div class="termos">
        <div class="lovers-checkbox__container">
          <input
            type="checkbox"
            name="termos"
            id="termos"
            [(ngModel)]="item.aceiteTermo"
          />
          <label class="termos__label" for="termos">
            Estou ciente e aceito os termos da política de privacidade da Cacau
            Show
          </label>
        </div>
      </div>

      <div class="container__botoes">
        <button
          class="lovers-button lovers-button-recusar"
          (click)="exibirRecusarSolicitacao(true, item)"
        >
          Recusar
        </button>
        <button
          [ngClass]="{ 'lovers--disabled': !item.aceiteTermo }"
          class="lovers-button lovers-button-aceitar"
          (click)="exibirAprovarSolicitacao(true, item)"
        >
          Aprovar
        </button>
      </div>
    </div>
  </div>

  <p
    class="header_status status__concluido"
    *ngIf="!exibeDivSemSolicitacoes && solicitacoesConcluidas.length > 0"
  >
    Concluídas
  </p>

  <div
    class="row"
    [ngClass]="div - card - pendente"
    *ngFor="let item of solicitacoesConcluidas; let i = index"
  >
    <div
      class="col-12 ja__aceito"
      [ngClass]="{
        'border--bottom': i < solicitacoesConcluidas.length - 1
      }"
    >
      <p class="font-titulo">
        <img class="statusMensagem" [src]="'assets/images/icons/lida.png'" />{{
          item.idTipoAprovacao == 1
            ? "Solicitação de cadastro de menor de idade"
            : ""
        }}
      </p>
      <p class="font-data">{{ item.dataInicio | date: "dd/MM/yyyy" }}</p>
      <p class="font-descricao" *ngIf="item.idStatus == 2">
        Você aprovou o cadastro de
        {{ item.descricaoSolicitante.split(" ")[0] }}.
      </p>
      <p class="font-descricao" *ngIf="item.idStatus == 3">
        Você rejeitou o cadastro de
        {{ item.descricaoSolicitante.split(" ")[0] }}.
      </p>
      <!-- <div class="container__botoes">
        <button
          class="lovers-button lovers-button-desfazer"
          (click)="exibirDesfazerSolicitacao(true, item)"
        >
          <img src="assets/images/icons/return.png" class="desfazer__icon" />
          Desfazer
        </button>
      </div> -->
    </div>
  </div>
  <div
    class="solicitacoes__ver__mais"
    (click)="onClickVerMais()"
    *ngIf="exibeBotaoVerMais"
  >
    <p class="ver__mais" *ngIf="exibirBotaoCarregarMais()">
      <img class="ver__mais__icone" src="assets/images/icons/mais.png" />
      Ver mais notificações
    </p>
  </div>

  <div class="container" *ngIf="carregandoSolicitacoes">
    <ngx-skeleton-loader
      count="4"
      [theme]="{
        'border-radius': '10px',
        height: '100px',
        width: '100%',
        display: 'block',
        margin: 'auto',
        'margin-bottom': '24px'
      }"
    ></ngx-skeleton-loader>
  </div>

  <!-- Modal Recusar Solicitação -->
  <lovers-popup
    [exibir]="exibirModalRecusarSolicitacao"
    (onClose)="exibirModalRecusarSolicitacao = false"
    tamanho="pequeno"
  >
    <div class="popup__header">
      <p class="header__title">Tem certeza que deseja recusar a solicitação?</p>
    </div>
    <div class="popup__footer">
      <div class="footer__content d-flex justify-content-center">
        <button
          class="lovers-button mr-4"
          (click)="exibirRecusarSolicitacao(false, null)"
        >
          Cancelar
        </button>
        <button
          class="lovers-button"
          style="background-color: #ff9999"
          (click)="recusarSolicitacao()"
        >
          Sim
        </button>
      </div>
    </div>
  </lovers-popup>

  <!-- Modal Desfazer Solicitação -->
  <lovers-popup
    [exibir]="exibirModalAprovarSolicitacao"
    (onClose)="exibirModalAprovarSolicitacao = false"
    tamanho="pequeno"
  >
    <div class="popup__header">
      <p class="header__title">Tem certeza que deseja aprovar a solicitação?</p>
    </div>
    <div class="popup__footer">
      <div class="footer__content d-flex justify-content-center">
        <button
          class="lovers-button mr-4"
          (click)="exibirAprovarSolicitacao(false, null)"
        >
          Cancelar
        </button>
        <button
          class="lovers-button"
          style="background-color: #ff9999"
          (click)="aprovarSolicitacao()"
        >
          Sim
        </button>
      </div>
    </div>
  </lovers-popup>

  <!-- Modal Desfazer Solicitação -->
  <lovers-popup
    [exibir]="exibirModalDesfazerSolicitacao"
    (onClose)="exibirModalDesfazerSolicitacao = false"
    tamanho="pequeno"
  >
    <div class="popup__header">
      <p class="header__title">
        Tem certeza que deseja desfazer a solicitação?
      </p>
    </div>
    <div class="popup__footer">
      <div class="footer__content d-flex justify-content-center">
        <button
          class="lovers-button mr-4"
          (click)="exibirDesfazerSolicitacao(false, null)"
        >
          Cancelar
        </button>
        <button
          class="lovers-button"
          style="background-color: #ff9999"
          (click)="desfazerSolicitacao()"
        >
          Sim
        </button>
      </div>
    </div>
  </lovers-popup>
</div>

<lovers-popup
  [exibir]="exibePopupGenerico"
  (onClose)="exibePopupGenerico = false"
  tamanho="grande"
>
  <div class="popup__header">
    <p class="header__title">{{ tituloModalGenerico }}</p>
  </div>
  <div class="popup__body">
    <div class="descricao">
      <label class="mb-0">
        <span *ngFor="let item of descricaoModalGenerico" [innerHtml]="item">
        </span>
      </label>
    </div>
  </div>
</lovers-popup>

<div class="container" *ngIf="carregandoSolicitacoes">
  <ngx-skeleton-loader
    count="4"
    [theme]="{
      'border-radius': '10px',
      height: '100px',
      width: '100%',
      display: 'block',
      margin: 'auto',
      'margin-bottom': '24px'
    }"
  ></ngx-skeleton-loader>
</div>
